import styled from 'styled-components';
import { IslandSectionContainer } from './IslandSectionContainer';

export const IslandFooter = styled(IslandSectionContainer).attrs({
  $spacing: 'medium',
})`
  align-items: center;
  flex-direction: row;
`;
